import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { AdminService, MetadataService, SessionService, AuthService, ApiService } from '../../services';
import { UscCampaignService } from '../../services/usc-campaign/usc-campaign.service';

@Component({
    selector: 'sn-usc-campaign',
    templateUrl: './usc-campaign.component.html',
    styleUrls: ['./usc-campaign.component.css']
})
export class UscCamaignComponent implements OnInit {

    constructor(
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public uscCampaignService: UscCampaignService
    ) {
        console.log('UscCampaignComponent constructor');
    }

    metaDataSub: Subscription;
    idleTimerSub: Subscription;

    ngOnInit() {
        this.sessionService.log("Meta Data Loading:", new Date());

        this.idleTimerSub = this.sessionService.onIdleTimeout().subscribe(c => {
            this.sessionService.log("Session Timeout");
            this.authService.logoff(true);
        });

        this.idleTimerSub = this.sessionService.customIdleLimitReached.subscribe(result => {
            if (result) {
                this.sessionService.log("Custom Session Timeout");
                this.authService.logoff(true);
            }
        });

    }

    loadMetaData(): Observable<any> {
        return this.metadataService.loadMetadata();
    }

    ngOnDestroy() {
        if (this.metaDataSub) this.metaDataSub.unsubscribe();
        if (this.idleTimerSub) this.idleTimerSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usc-campaign.component.ts